// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-input-wrapper .text-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(60, 67, 74, 0.5019607843);
  background-color: transparent;
  padding: 7px 10px;
  border-radius: 3px;
  color: #3c434a;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  width: 100%;
  max-width: 375px;
}
.text-input-wrapper .text-input:focus {
  outline: none;
  border-color: unset;
  box-shadow: unset;
}
.text-input-wrapper .text-input::placeholder {
  color: #999;
}
.text-input-wrapper .number-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(60, 67, 74, 0.5019607843);
  background-color: transparent;
  padding: 7px 10px;
  border-radius: 3px;
  color: #3c434a;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  width: 100%;
  max-width: 100px;
}
.text-input-wrapper .number-input:focus {
  outline: none;
}
.text-input-wrapper .number-input::placeholder {
  color: #999;
}`, "",{"version":3,"sources":["webpack://./src/components/InputBox/InputBox.scss"],"names":[],"mappings":"AAEI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AADR;AAGM;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AADR;AAIM;EACE,WAAA;AAFR;AAKI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAHR;AAKM;EACE,aAAA;AAHR;AAMM;EACE,WAAA;AAJR","sourcesContent":[".text-input-wrapper {\n    \n    .text-input {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        border: 1px solid rgba(60, 67, 74, 0.5019607843);\n        background-color: transparent;\n        padding: 7px 10px;\n        border-radius: 3px;\n        color: #3c434a;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 22px;\n        letter-spacing: 0%;\n        width: 100%;\n        max-width: 375px;\n      \n      &:focus {\n        outline: none;\n        border-color: unset;\n        box-shadow:unset;\n      }\n      \n      &::placeholder {\n        color: #999;\n      }\n    }\n    .number-input {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        border: 1px solid rgba(60, 67, 74, 0.5019607843);\n        background-color: transparent;\n        padding: 7px 10px;\n        border-radius: 3px;\n        color: #3c434a;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 22px;\n        letter-spacing: 0%;\n        width: 100%;\n        max-width: 100px;\n      \n      &:focus {\n        outline: none;\n      }\n      \n      &::placeholder {\n        color: #999;\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
